/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#3778C2';

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		minHeight: 40,
	},

	cell: {
		fontSize: 8,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: borderColor,
		justifyContent: 'center',
	},

	id: { width: '6%', textAlign: 'center', borderLeftWidth: 1, borderLeftColor: borderColor,height:'100%'},
	name: { width: '14%', textAlign: 'left',height:'100%' },
	allocation: { width: '10%', textAlign: 'center',height:'100%' },
	incoming: { width: '14%', textAlign: 'left',height:'100%' },
	outgoing: { width: '14%', textAlign: 'left',height:'100%' },
	chainage: { width: '10%', textAlign: 'center',height:'100%' },
	remarks: { width: '16%', textAlign: 'left',height:'100%' },
	

	// last column (no right border)
	shift: { 
		width: '16%', 
		textAlign: 'center', 
		borderRightWidth: 1,
		height:'100%'
	},

	endborder: {
		borderBottomColor: borderColor,
		borderBottomWidth: 1,
		width: '100%',
	}
});

const InvoiceTableRow = (props) => {
	const rows = props.data?.map((item, index) => (
		<View key={index} wrap={false}>
      
			<View style={styles.row}>
				<Text style={[styles.cell, styles.id]}>{item.id}</Text>
				<Text style={[styles.cell, styles.name]}>{item.name}</Text>
				<Text style={[styles.cell, styles.allocation]}>{item.allocationId}</Text>
				<Text style={[styles.cell, styles.incoming]}>{item.incomingUser}</Text>
				<Text style={[styles.cell, styles.outgoing]}>{item.outgoingUser}</Text>
				<Text style={[styles.cell, styles.chainage]}>{item.pipelineChainage}</Text>
				<Text style={[styles.cell, styles.remarks]}>{item.remarks || '-'}</Text>
				<Text style={[styles.cell, styles.shift]}>{item.shiftDateTime}</Text>
			</View>

			<View style={styles.endborder} />
		</View>
	));

	return <>{rows}</>;
};

export default InvoiceTableRow;